/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it validate Roman numerals?`)
};

const es_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Valida numerales romanos?`)
};

const de_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden römische Zahlen validiert?`)
};

const nl_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valideert het Romeinse getallen?`)
};

const fr_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valide-t-il les chiffres romains ?`)
};

const it_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convalida i numerali romani?`)
};

const pt_br2_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele valida numerais romanos?`)
};

const pt_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valida numerais romanos?`)
};

const ja_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローマ数字を検証しますか?`)
};

const zh_rn_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会验证罗马数字吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq2_q", locale)
	if (locale === "en") return en_rn_faq2_q(inputs)
	if (locale === "es") return es_rn_faq2_q(inputs)
	if (locale === "de") return de_rn_faq2_q(inputs)
	if (locale === "nl") return nl_rn_faq2_q(inputs)
	if (locale === "fr") return fr_rn_faq2_q(inputs)
	if (locale === "it") return it_rn_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq2_q(inputs)
	if (locale === "pt") return pt_rn_faq2_q(inputs)
	if (locale === "ja") return ja_rn_faq2_q(inputs)
	return zh_rn_faq2_q(inputs)
};